// hooks/league/useFetchUserLeagues.js
import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { useFetchUser } from "../user/useFetchUser";

const fetchUserLeagues = async (userId, token) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const { data } = await axios.get(
    `${apiUrl}/api/league/list-leagues/${userId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return data;
};

// Original hook that requires userId to be passed
export const useUserLeagues = (userId) => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    ["userLeagues", userId],
    async () => {
      const token = await getAccessTokenSilently();
      return fetchUserLeagues(userId, token);
    },
    {
      enabled: !!userId, // Only run the query if the userId is available
    }
  );
};

// New hook that automatically gets the current user ID
export const useFetchUserLeagues = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { data: user } = useFetchUser();

  return useQuery(
    ["userLeagues", user?._id],
    async () => {
      const token = await getAccessTokenSilently();
      return fetchUserLeagues(user._id, token);
    },
    {
      enabled: !!user?._id, // Only run the query if the user ID is available
      staleTime: 60000, // 1 minute
    }
  );
};
